import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SalesComponent } from '../sales-module/sales/sales.component';
import { LeadsComponent } from '../sales-module/leads/leads.component';
import { LeadsDetailsComponent } from './leads/leads-details/leads-details.component';

const salesModuleRoutes: Routes = [
  { path: 'sales/:cnpj', component: SalesComponent },
  { path: 'leads/:cnpj', component: LeadsComponent },
  { path: 'leads/:cnpj/:id', component: LeadsDetailsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(salesModuleRoutes)],
  exports: [RouterModule],
})
export class SalesModuleRoutingModule {}
